import React, { ReactElement, SyntheticEvent, useState } from 'react';

import { Box, Tooltip } from '@mui/material';

import type { CompetitorHotelOpportunities } from '~/types/services/priceParrot';

import CompetitorOfferOpportunitiesDetail from './CompetitorOfferOpportunitiesDetail';
import { PAPER_TOOLTIP_SX } from './constants';

// The tooltip renders in a portal but its React events still bubble to the grid cell, which would take
// clicks, text selection and Ctrl+C for itself. Escape is left to the tooltip, which closes on it.
const stopGridEvent = (event: SyntheticEvent) => event.stopPropagation();
const stopGridKey = (event: React.KeyboardEvent) => event.key !== 'Escape' && event.stopPropagation();

interface Props {
  hotelName: string;
  opportunities: CompetitorHotelOpportunities;
  userLocations: Array<string>;
  children: ReactElement;
}

export default function CompetitorOfferOpportunitiesTooltip({
  hotelName,
  opportunities,
  userLocations,
  children,
}: Props) {
  const [hovered, setHovered] = useState(false);
  const [pinned, setPinned] = useState(false);

  return (
    <Tooltip
      open={hovered || pinned}
      onOpen={() => setHovered(true)}
      onClose={(event) => {
        setHovered(false);
        if (event.type === 'keydown') {
          setPinned(false);
        }
      }}
      enterDelay={300}
      placement="bottom-start"
      slotProps={{ tooltip: { sx: PAPER_TOOLTIP_SX } }}
      title={
        <Box onClick={stopGridEvent} onMouseDown={stopGridEvent} onKeyDown={stopGridKey}>
          <CompetitorOfferOpportunitiesDetail
            hotelName={hotelName}
            opportunities={opportunities}
            userLocations={userLocations}
            pinned={pinned}
            onPinnedChange={setPinned}
          />
        </Box>
      }
    >
      {children}
    </Tooltip>
  );
}
